import { cn } from "@/utils/cn";
import { memo } from "react";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "w-10 h-10 border-2",
  md: "w-20.5 h-20.5 border-4",
  lg: "w-32 h-32 border-4",
};

export const LoadingSpinner = memo(function LoadingSpinner({
  className,
  size = "md",
}: LoadingSpinnerProps) {
  return (
    <div
      className={cn(
        "rounded-full border-transparent border-x-black border-b-black animate-spin",
        sizeClasses[size],
        className,
      )}
      role="status"
      aria-label="Loading"
    />
  );
});
